module.exports = __webpack_public_path__ + "static/media/roiStandIn.d561cd70.png";